// extracted by mini-css-extract-plugin
export var root = "c9aF";
export var rootIcon = "kVHf";
export var rootIconWrapper = "oCev";
export var rootIsPlaying = "_7Hdt";
export var rootThumbnail = "ZJ1R";
export var rootThumbnailImg = "_5FC2";
export var rootVideo = "fy1c";
export var rootVideoPlaying = "UsHQ";